import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const mediaBanner = (): void => {
  const parallaxElements = document.querySelectorAll<HTMLElement>(
    '[data-media-banner-parallax]'
  );

  if (!parallaxElements.length) return;

  // Only enable parallax on desktop (lg breakpoint and above)
  const mediaQuery = window.matchMedia('(min-width: 1024px)');

  const initParallax = (): void => {
    if (!mediaQuery.matches) return;

    parallaxElements.forEach((element) => {
      const banner = element.closest('[data-media-banner]');
      if (!banner) return;

      gsap.to(element, {
        yPercent: 20,
        ease: 'none',
        scrollTrigger: {
          trigger: banner,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    });
  };

  const destroyParallax = (): void => {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (
        parallaxElements.length &&
        Array.from(parallaxElements).some(
          (el) => el === trigger.vars.trigger || el.closest('[data-media-banner]') === trigger.vars.trigger
        )
      ) {
        trigger.kill();
      }
    });

    // Reset transforms
    parallaxElements.forEach((element) => {
      gsap.set(element, { clearProps: 'all' });
    });
  };

  // Handle resize
  const handleResize = (): void => {
    if (mediaQuery.matches) {
      initParallax();
    } else {
      destroyParallax();
    }
  };

  // Initial setup
  initParallax();

  // Listen for viewport changes
  mediaQuery.addEventListener('change', handleResize);
};

export default mediaBanner;
